<template>
  <div class="">
    <div class="box-main">
    <div class="main">
      <div v-for="(item, index) in apiData" :key="index" class="mainTab">
        <div class="title main-title main-title--first">{{ item.mainTitle }}</div>
        <div v-if="item.h2Title" class="title h2-title h2-title--lead">
          {{ item.h2Title }}
        </div>
        <div class="pre-container">
          <pre class="doc-pre">
            <span v-for="(line, idx) in item.codeLines" :key="idx" class="span-content">
              {{ idx + 1 }}  <span v-html="line" /><br>
            </span>
          </pre>
          <el-button @click="copyToClipboard(item.codeLines)" class="copy-button" type="primary" size="mini">复制</el-button>
        </div>
        <div class="content">
          {{ item.description }}
        </div>
      
            <div v-for="(it,int) in item.apiDesc" :key="int">
              <div class="title h2-title h2-title--block">{{ it.h2Title }}</div>
              <div class="title h2-title h2-title--section">{{item.apiAdd}}-1 请求报文示例</div>
              <div class="content flx"><i>接口地址：</i>
              <div class="black-content"> {{ it.requestUrl }}</div>
            </div>
            <div class="content flx" v-if="it.description !==''"><i>接口描述：</i>
              <div class="black-content">{{ it.description }}</div>
            </div>
            <div class="content flx" v-if="it.type !==''"><i>请求数据类型：</i>
              <div class="black-content">{{ it.type }}</div>
            </div>
            <div class="title h2-title">{{item.apiAdd}}-2 请求字段解析</div>
            <div class="pre-container">
              <pre class="doc-pre">
                <span v-for="(line, idx) in it.codeLines" :key="idx" class="span-content">
                  {{ idx + 1 }}  <span v-html="line" /><br>
                </span>
              </pre>
              <el-button @click="copyToClipboard(it.codeLines)" class="copy-button" type="primary" size="mini">复制</el-button>
            </div>
            <div class="title h2-title">{{item.apiAdd}}-3 请求参数说明</div>
            <div v-if="it.description1" class="content content--tip">
              {{ it.description1 }}
            </div>
            <el-table :data="it.tableData" row-key="id"
                border
                :row-class-name="( row, rowIndex )=>rowClassName( row, rowIndex)"
                default-expand-all
                :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
              <el-table-column prop="field" width="300" label="参数名称" show-overflow-tooltip />
              <el-table-column prop="fieldName" label="参数说明" show-overflow-tooltip />
              <el-table-column prop="required" label="是否必填" show-overflow-tooltip />
              <el-table-column prop="dataType" label="数据类型" show-overflow-tooltip />
              <el-table-column prop="example" label="示例值" show-overflow-tooltip />
              <el-table-column prop="description" label="描述" width="300" show-overflow-tooltip />
            </el-table>
            <div class="title h2-title h2-title--section">{{item.apiAdd}}-4 返回示例</div>
            <div class="pre-container">
              <pre class="doc-pre">
                <span v-for="(line, idx) in it.codeLines1" :key="idx" class="span-content">
                  {{ idx + 1 }} <span v-html="line" /><br>
                </span>
              </pre>
              <el-button @click="copyToClipboard(it.codeLines1)" class="copy-button" type="primary" size="mini">复制</el-button>
            </div>
          <div v-if="it.codeLines2 !==''">
            <div class="title h2-title h2-title--section">{{item.apiAdd}}-5 返回参数说明</div>
            <div class="pre-container">
              <pre class="doc-pre">
                <span v-for="(line, idx) in it.codeLines2" :key="idx" class="span-content">
                  {{ idx + 1 }} <span v-html="line" /><br>
                </span>
              </pre>
              <el-button @click="copyToClipboard(it.codeLines2)" class="copy-button" type="primary" size="mini">复制</el-button>
            </div>
          </div>
          <div v-if="it.resultEmbedUrl" class="result-embed-section">
            <div class="title h2-title h2-title--section">{{ item.apiAdd }}-6 返回结果展示</div>
            <div class="result-embed-toolbar content flx">
              <span>在线预览渠道表格接口返回页面</span>
              <div class="result-embed-actions">
                <el-button class="copy-button" type="primary" size="mini"  @click="openResultEmbed(it.resultEmbedUrl)">新窗口打开</el-button>
              </div>
            </div>
            <div class="result-embed-html-wrap">
              <div v-if="embedStatus(it.resultEmbedUrl).loading" class="result-embed-status">加载中…</div>
              <div v-else-if="embedStatus(it.resultEmbedUrl).error" class="result-embed-status result-embed-error">
                {{ embedStatus(it.resultEmbedUrl).error }}
              </div>
              <div
                v-else
                class="result-embed-html channel-remote-html"
                v-html="embedStatus(it.resultEmbedUrl).html"
              />
            </div>
          </div>
          </div>

        </div>

        </div>
       
    </div>
  </div>
</template>

<script>
export default {
  name: "mainComponents",
  data() {
    return {
      searchQuery: "",
      totalIndex: 1,
      propList: [],
      apiData: [],
      /** 远程 HTML 嵌入：key 为原始页面 URL（与 it.resultEmbedUrl 一致） */
      resultEmbedByUrl: {},
      allData : [
      {
          api:'1-0',
          apiAdd:'1',
          selectedVersion:'V1.0',
          mainTitle: '账户验证接口HTTP请求头格式',
          h2Title1: '',
          description: '',
          codeLines: `          Host:请求ip+端口号
          Content-Type:multipart/form-data`.split('\n'),
          apiDesc:[
            {
              h2Title: '账户验证',
              requestUrl: '[POST] /v1/user/oauth/token',
              type:"formdata",
              description:"",
                  codeLines: `      
                  grant_type="password"
                  client_id="aaf"
                  client_secret="aaf88888888"
                  username="17777777777"
                  password="123456"
                  login_type="api_key"
                  user_type="1"`.split('\n'),
                  codeLines1: `                 {
                  "access_token":
                          "eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJicmFuY2hJZCI6IjAwYzgwNzBiNzBhMTQ3NWQ5MGE0NzI0MzMxYj
                          g0ZDNhIiwiYWdlbnRJZCI6IjA2NTVmNzI5ZGY3MTQ4ZTZiNDQ4ZDBmMGIzNTdiOTlmIiwiY29kZSI6MjAwLCJ1c2VyX2
                          5hbWUiOiIxNzc3Nzc3Nzc3NyIsImFnZW50TmFtZSI6IjE3Nzc3Nzc3Nzc3IiwidXNlck5hbWUiOiJudWxsIG51bGwiLC
                          J1c2VySWQiOiIwNjU1ZjcyOWRmNzE0OGU2YjQ0OGQwZjBiMzU3Yjk5ZiIsImF1dGhvcml0aWVzIjpbInVzZXIiLCJhZG
                          1pbiJdLCJ1c2VyQ29kZSI6bnVsbCwiY2xpZW50X2lkIjoiYWFmIiwiaXNJbml0UHdkIjoiZmFsc2UiLCJzY29wZSI6Wy
                          JhbGwiXSwiZXhwIjoxNzIwNjY5NjEwLCJqdGkiOiIxZWYyODZiYS1jZGYyLTRkN2EtOWVjYS04NmU0MGI0N2E0OGEifQ.
                          jzqOHTzmbM4mQL4oqLacIS2AXx3b4ZCYh9M8imrNcU_mhMuNnZlsFznmj1Z1_kW71CM0kr5dCzR4egy17UhCasAoWe6B
                          dtw3gPMBvlpS3IJ5b8fvwFkorHXqU9xwfpB8PdhHAPPBPUduIrlYMPRnocUxCTftMeMm7TThQERKltiCXRS3nNzwopzz
                          -daKwfRgFS9U8i1q_noynL-Ood5eG30QwD6mI4M-_wjS3jSgBNKT6Kr4moWjiwyoNQdx14DrFGKsolI3WRRIW_q1s1X5
                          P8sAVGRSIKLeTp3yN92LarE3TqzGbZWBhnhvD9_5W8D8U-glAbvDTGFREEdgkAQgfg",
                  "token_type":"bearer",
                  "refresh_token":
                          "eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJicmFuY2hJZCI6IjAwYzgwNzBiNzBhMTQ3NWQ5MGE0NzI0MzMxYj
                          g0ZDNhIiwiYWdlbnRJZCI6IjA2NTVmNzI5ZGY3MTQ4ZTZiNDQ4ZDBmMGIzNTdiOTlmIiwiY29kZSI6MjAwLCJ1c2VyX2
                          5hbWUiOiIxNzc3Nzc3Nzc3NyIsImFnZW50TmFtZSI6IjE3Nzc3Nzc3Nzc3IiwidXNlck5hbWUiOiJudWxsIG51bGwiLC
                          J1c2VySWQiOiIwNjU1ZjcyOWRmNzE0OGU2YjQ0OGQwZjBiMzU3Yjk5ZiIsImF1dGhvcml0aWVzIjpbInVzZXIiLCJhZG
                          1pbiJdLCJ1c2VyQ29kZSI6bnVsbCwiY2xpZW50X2lkIjoiYWFmIiwiaXNJbml0UHdkIjoiZmFsc2UiLCJzY29wZSI6Wy
                          JhbGwiXSwiYXRpIjoiMWVmMjg2YmEtY2RmMi00ZDdhLTllY2EtODZlNDBiNDdhNDhhIiwiZXhwIjoxNzIwNjY5NjEwLC
                          JqdGkiOiI0OTVjYzc0MC00MmZlLTQ2ZjMtOGQ5Mi05ZjI3NmIzOTNhZTEifQ.So-P4-9POyrVsDq2aJc8XrNj9NoZG1_
                          g9c-rbkz_59So3z1T3mtqripoIvJnrTRGxEC7IZcEpOX-BT_OB1YA8JrjI5fBiMpzBQdYBoCCHlOe_HUoiYpfS6ox5ql
                          wS1dCQXZGVYa6jxSE0CHKd1ZjofNRbBcbyJ5AOYny2qsYuFjuww5x709hNNpZD5quJjjVsWqbPFmZw8YL1tHgPyf251V
                          5mHN04b1RqnCOohDikWYe9bVTj2wxM0VYo8kZPEaQsao_luZwMh0pUsrIZEHgr6Eu5GEi73TjnYT2bTpKH_9-Wy1Am4E
                          ZPo-M9vvOgPSYGLp1_efxjh7cx-4Tnmkb2w",
                  "expires_in":604799,
                  "scope":"all",
                  "branchId":"00c8070b70a1475d90a4724331b84d3a",
                  "isInitPwd":"false",
                  "agentId":"0655f729df7148e6b448d0f0b357b99f",
                  "code":200,
                  "agentName":"17777777777",
                  "userName":"nullnull",
                  "userId":"0655f729df7148e6b448d0f0b357b99f",
                  "userCode":null,
                  "jti":"1ef286ba-cdf2-4d7a-9eca-86e40b47a48a"
                  }`.split('\n'),
                  codeLines2: `          access_token：访问令牌，拼接固定前缀"Bearer"组成后续接口的访问token`.split('\n'),
              tableData:[
              { id: 'grant_type', field: 'grant_type', fieldName: '授权类型', required: '是', dataType: 'string', example: 'password', description: '固定值' },
              { id: 'client_id', field: 'client_id', fieldName: '客户端id', required: '是', dataType: 'string', example: 'aaf', description: '固定值' },
              { id: 'client_secret', field: 'client_secret', fieldName: '客户端密钥', required: '是', dataType: 'string', example: 'aaf88888888', description: '固定值' },
              { id: 'username', field: 'username', fieldName: '用户名', required: '是', dataType: 'string', example: '17777777777', description: '生产环境账户&密钥从客户端右上角apiKey获取' },
              { id: 'password', field: 'password', fieldName: '密码', required: '是', dataType: 'string', example: '123456', description: '生产环境账户&密钥从客户端右上角apiKey获取' },
              { id: 'login_type', field: 'login_type', fieldName: '登录类型', required: '是', dataType: 'string', example: 'api_key', description: '固定值' },
              { id: 'user_type', field: 'user_type', fieldName: '用户类型', required: '是', dataType: 'string', example: '1', description: '固定值' },
              
                 
                ]
            },
          ],
        },
        {
          api:'2-0',
          apiAdd:'1',
          selectedVersion:'V1.0',
          mainTitle: '常规接口HTTP请求头格式',
          h2Title1: '',
          description: '',
          codeLines: `          Authorization:Bearer ACCESS_TOKEN
          Content-Type:application/json`.split('\n'),
          apiDesc:[
            {
              h2Title: '创建订单',
              requestUrl: '[POST] /v1/order/aafOrder/createOrder',
              type:"application/json",
              description:"",
                  codeLines: `      {
                  "transportMode": "OCEAN",
                  "forecastNumber": 2,
                  "taxType": "4",
                  "taxNo": "GB379568820",
                  "cur": "USD",
                  "countryCode": "GB",
                  "channelId": "0b5d72fb65c741489f9031e544c305a7",
                  "declareType": "2",
                  "receiveType": "1",
                  "takeType": "2",
                  "orderRemark": "备注",
                  "orderGoodsList": [
                      {
                          "boxNo": "FBAABCD1234U000001",
                          "referenceId": 1,
                          "boxWeight": 100,
                          "length": 100,
                          "width": 100,
                          "height": 100,
                          "skuEnglishName": "Bluetooth Earphones",
                          "skuName": "蓝牙耳机",
                          "declarePrice": 2.7,
                          "number": 100,
                          "clearanceHscode": "123",
                          "brand": "无",
                          "model": "ABC",
                          "material": "塑料",
                          "purpose": "手机配件",
                          "saleUrl": "https://www.amazon.co.gb/dp/ABCD1234",
                          "picUrl": null,
                          "productWeight": null,
                          "purchasePrice": 2.7,
                          "asin": null,
                          "sku": null
                      },
                      {
                          "boxNo": "FBAABCD1234U000002",
                          "referenceId": "1",
                          "boxWeight": 20,
                          "length": 54,
                          "width": 33,
                          "height": 32,
                          "skuEnglishName": "Bluetooth Earphones",
                          "skuName": "蓝牙耳机",
                          "declarePrice": 1,
                          "number": 60,
                          "clearanceHscode": "123",
                          "brand": "无",
                          "model": "-",
                          "material": "塑料",
                          "purpose": "手机配件",
                          "saleUrl": "-",
                          "picUrl": "-",
                          "productWeight": 1,
                          "purchasePrice": 1,
                          "asin": "-",
                          "sku": "SG-SZRL-0012-US-Y"
                      }
                  ],
                  "goodsAttrTypeList": [
                      "4",
                      "2"
                  ],
                  "orderReceive": {
                      "fbaWarehouseCode": "LPL2"
                  }
              }`.split('\n'),
                  codeLines1: `                 {
                  "success": true,
                  "reTry": false,
                  "message": "下单成功，您的订单是：AABB2407010041",
                  "code": 200,
                  "data": "8175052ed64143f093c401feb91346ec",
                  "timestamp": 1719836214170
              }`.split('\n'),
                  codeLines2: `          success:请求成功标志，true仅代表请求成功，不代表通过
          message：请求描述
          code:200则代表请求通过，完成下单，500则代表校验未通过
          id:订单id，系统生成的唯一序列号
          orderNo：订单号，系统生成的唯一订单号`.split('\n'),
              tableData:[
              { id: 'transportMode', field: 'transportMode', fieldName: '运输方式', required: '是', dataType: 'string', example: 'AIR', description: '海运-OCEAN, 空运-AIR, 铁路-RAIL, 卡航-ROAD, 快递-EXPRESS' },
                { id: 'countryCode', field: 'countryCode', fieldName: '国家编码', required: '是', dataType: 'string', example: 'GB', description: '国家二字码' },
                { id: 'channelId', field: 'channelId', fieldName: '渠道id', required: '是', dataType: 'string', example: '73d277d502024515b92ecf9e95c048df', description: '通过渠道信息接口获取' },
                { id: 'custOrderNo', field: 'custOrderNo', fieldName: '客户订单号', required: '否', dataType: 'string', example: 'GZGM2406171807', description: '客户订单号' },
                // { id: 'isPurchaseInsurance', field: 'isPurchaseInsurance', fieldName: '是否购买保险', required: '是', dataType: 'string', example: '1', description: '0:否 1:是' },
                // { id: 'insuranceType', field: 'insuranceType', fieldName: '投保类型', required: '否', dataType: 'string', example: '1', description: '1-上架险，2-签收险' },
                // { id: 'insuranceCurrency', field: 'insuranceCurrency', fieldName: '保险币种', required: '否', dataType: 'string', example: 'CNY', description: '币种' },
                // { id: 'insuranceAmount', field: 'insuranceAmount', fieldName: '购买保险金额', required: '否', dataType: 'string', example: '500.00', description: '金额' },
                { id: 'taxNo', field: 'taxNo', fieldName: '税号', required: '是', dataType: 'string', example: 'GB123456789', description: '税号' },
                { id: 'cur23', field: 'cur', fieldName: '申报币种', required: '是', dataType: 'string', example: '', description: '申报币种' },
                // { id: 'isSpecifyDelivery', field: 'isSpecifyDelivery', fieldName: '是否指定末端快递', required: '否', dataType: 'string', example: '0', description: '0:否 1:是' },
                // { id: 'deliveryCompanyId', field: 'deliveryCompanyId', fieldName: '快递公司id', required: '否', dataType: 'string', example: '73d277d502024515b92ecf9e95c048df', description: '根据快递公司信息接口获取' },
                { id: 'forecastNumber', field: 'forecastNumber', fieldName: '箱数', required: '是', dataType: 'integer(int32)', example: '10', description: '订单箱数' },
                // { id: 'forecastWeight', field: 'forecastWeight', fieldName: '预报重量', required: '是', dataType: 'number', example: '50.00', description: '重量(KG)' },
                // { id: 'forecastVolume', field: 'forecastVolume', fieldName: '预报体积', required: '是', dataType: 'number', example: '1.00', description: '体积(M³)' },
                // { id: 'isArrangeInspection', field: 'isArrangeInspection', fieldName: '是否安排商检', required: '否', dataType: 'string', example: '0', description: '0:否 1:是' },
                { id: 'declareType1', field: 'declareType', fieldName: '报关方式', required: '是', dataType: 'string', example: '1', description: '1:代理报关 2:报关退税 3:代理+报关退税' },
                // { id: 'taxRefundInfo', field: 'taxRefundInfo', fieldName: '退税资料url', required: '否', dataType: 'string', example: 'https://public-shenzhen-file.oss-cn-beijing.aliyuncs.com/aaf1.0/file/退税资料.zip', description: '文件下载地址' },
                // { id: 'taxRefundRemark', field: 'taxRefundRemark', fieldName: '退税资料说明', required: '是', dataType: 'string', example: '1', description: '1-一对多（单订单多份资料）, 2-一对一（单订单一份资料）, 3-多对多（合并报关，多份资料）, 4-多对一（合并报关，一份资料）；报关方式为代理+退税则必填' },
                { id: 'taxType', field: 'taxType', fieldName: '交税方式', required: '是', dataType: 'string', example: '1', description: '1-不包税，2-包税，4-自税递延，5-自税不递延' },
                { id: 'receiveType', field: 'receiveType', fieldName: '地址类型', required: '是', dataType: 'string', example: '1', description: '1:FBA地址 2：第三方海外仓 3：私人地址' },
                { id: 'takeType', field: 'takeType', fieldName: '提货方式', required: '是', dataType: 'string', example: '1', description: '1:自送到仓 2:上门提货 3:工厂装货(柜)' },
                { id: 'orderRemark', field: 'orderRemark', fieldName: '备注', required: '否', dataType: 'string', example: '', description: '' },
                { id: 'goodsAttrTypeList', field: 'goodsAttrTypeList', fieldName: '产品属性列表', required: '是', dataType: 'array', example: '["1","2"]', description: '1-普货 2-带电 3-带磁 4-液体 5-粉末 6-危险品 7-木制品 8-商检 9-熏蒸' },
                // { id: 'goodsAttrObj', field: 'goodsAttrObj', fieldName: '电池信息', required: '是', dataType: 'object', example: '{}', description: '如果产品属性列表带电，需要填写电池信息',children:[
                //    { id: 'batteryType', field: 'batteryType', fieldName: '电池类型', required: '是', dataType: 'string', example: '1', description: '1:干电池 2:纽扣电池 3:锂电池 4:镍氢电池' },
                //    { id: 'documents', field: 'documents', fieldName: '鉴定文件', required: '否', dataType: 'string', example: '', description: '文件下载地址' },
                //    { id: 'power', field: 'power', fieldName: '功率', required: '是', dataType: 'string', example: '100', description: '电池锂电池、镍氢电池必填' },
                //    { id: 'watts', field: 'watts', fieldName: '瓦数', required: '是', dataType: 'string', example: '100', description: '电池类型为锂电池、镍氢电池必填' },
                //    ] 
                // },
                { id: 'orderGoodsList', field: 'orderGoodsList', fieldName: '货物/产品明细', required: '是', dataType: 'array', example: '{}', description: '订单产品信息列表',children:[
                    { id: 'boxNo', field: 'boxNo', fieldName: '货箱编号', required: '是', dataType: 'string', example: 'FBAABCD1234U000001', description: '货箱编号：如果收件地址类型是FBA，需要通过正则校验：^FBA[A-Z0-9]+U[0-9]{6}$' },
                    { id: 'referenceId', field: 'referenceId', fieldName: 'PO Number', required: '否', dataType: 'string', example: '', description: '亚马逊后台的货件追踪编号' },
                    { id: 'boxWeight', field: 'boxWeight', fieldName: '单箱货箱重量(KG)', required: '是', dataType: 'number', example: '10', description: '' },
                    { id: 'length', field: 'length', fieldName: '货箱长度(CM)', required: '是', dataType: 'number', example: '100', description: '' },
                    { id: 'width', field: 'width', fieldName: '货箱宽度(CM)', required: '是', dataType: 'number', example: '100', description: '' },
                    { id: 'height', field: 'height', fieldName: '货箱高度(CM)', required: '是', dataType: 'number', example: '100', description: '' },
                    { id: 'skuEnglishName', field: 'skuEnglishName', fieldName: '产品英文品名', required: '是', dataType: 'string', example: 'Bluetooth Earphones', description: '' },
                    { id: 'skuName', field: 'skuName', fieldName: '产品中文品名', required: '是', dataType: 'string', example: '蓝牙耳机', description: '' },
                    { id: 'declarePrice', field: 'declarePrice', fieldName: '（单个产品）申报单价', required: '是', dataType: 'number', example: '2.7', description: '' },
                    { id: 'number', field: 'number', fieldName: '（单箱）申报数量', required: '是', dataType: 'integer', example: '100', description: '' },
                    // { id: 'exportHscode', field: 'exportHscode', fieldName: '产品海关编码(出口)', required: '是', dataType: 'string', example: '', description: '' },
                    { id: 'clearanceHscode', field: 'clearanceHscode', fieldName: '产品海关编码(清关)', required: '是', dataType: 'string', example: '', description: '' },
                    { id: 'brand', field: 'brand', fieldName: '产品品牌/商标', required: '是', dataType: 'string', example: '无', description: '' },
                    // { id: 'brandType', field: 'brandType', fieldName: '品牌类型', required: '是', dataType: 'string', example: '1', description: '1：无品牌 2：境内自主品牌 3：境内收购品牌 4：境外品牌（贴牌生产） 5：境外品牌（其他）' },
                    { id: 'model', field: 'model', fieldName: '产品型号', required: '是', dataType: 'string', example: 'ABC', description: '' },
                    { id: 'material', field: 'material', fieldName: '产品属性，材质', required: '是', dataType: 'string', example: '塑料', description: '' },
                    { id: 'purpose', field: 'purpose', fieldName: '产品用途', required: '是', dataType: 'string', example: '手机配件', description: '' },
                    { id: 'saleUrl', field: 'saleUrl', fieldName: '产品销售链接', required: '是', dataType: 'string', example: 'https://www.amazon.co.gb/dp/ABCD1234', description: '' },
                    { id: 'salesPrice', field: 'salesPrice', fieldName: '产品销售价格', required: '否', dataType: 'number', example: '', description: '' },
                    { id: 'picUrl', field: 'picUrl', fieldName: '产品图片链接', required: '否', dataType: 'string', example: '', description: '' },
                    { id: 'productWeight', field: 'productWeight', fieldName: '（单个产品）产品重量(kg)', required: '否', dataType: 'number', example: '', description: '' },
                    { id: 'purchasePrice', field: 'purchasePrice', fieldName: '产品采购单价', required: '是', dataType: 'number', example: '2.7', description: '' },
                    { id: 'asin', field: 'asin', fieldName: '产品ASIN', required: '否', dataType: 'string', example: '', description: '' },
                    { id: 'description', field: 'description', fieldName: '产品描述', required: '否', dataType: 'string', example: '', description: '' },
                    { id: 'sku', field: 'sku', fieldName: '客户产品SKU', required: '否', dataType: 'string', example: '', description: '' },
                    // { id: 'isElectric', field: 'isElectric', fieldName: '是否带电', required: '是', dataType: 'string', example: '1', description: '' },
                    // { id: 'isMagnetic', field: 'isMagnetic', fieldName: '是否带磁', required: '是', dataType: 'string', example: '0', description: '' },
                    // { id: 'isLiquid', field: 'isLiquid', fieldName: '是否液体', required: '否', dataType: 'string', example: '', description: '' },
                    // { id: 'isPowder', field: 'isPowder', fieldName: '是否粉末', required: '否', dataType: 'string', example: '', description: '' },
                    // { id: 'isHazardous', field: 'isHazardous', fieldName: '是否危险品', required: '否', dataType: 'string', example: '', description: '' },
                    // { id: 'isWooden', field: 'isWooden', fieldName: '是否木制品', required: '否', dataType: 'string', example: '', description: '' },
                    ] 
                },
                { id: 'orderReceive', field: 'orderReceive', fieldName: '收件地址类型详情', required: '是', dataType: '订单收件信息', example: '{}', description: '订单收件信息',children:[
                    { id: 'fbaWarehouseCode', field: 'fbaWarehouseCode', fieldName: 'FBA仓库编号', required: '是', dataType: 'string', example: 'ORF2', description: '收件地址类型是FBA，则必填' },
                    { id: 'tpWarehouseName', field: 'tpWarehouseName', fieldName: '第三方海外仓名称', required: '是', dataType: 'string', example: '', description: '收件地址类型是第三方海外仓，则必填' },
                    { id: 'inBoundCode', field: 'inBoundCode', fieldName: '第三方海外仓的入仓代码', required: '否', dataType: 'string', example: '', description: '收件地址类型是第三方海外仓，可选填' },
                    { id: 'state', field: 'state', fieldName: '省/州地区', required: '是', dataType: 'string', example: '', description: '第三方海外仓，私人地址必填' },
                    { id: 'city1', field: 'city', fieldName: '城市', required: '是', dataType: 'string', example: '', description: '第三方海外仓，私人地址必填' },
                    { id: 'receivePostcode', field: 'receivePostcode', fieldName: '收件人邮编', required: '是', dataType: 'string', example: '', description: '第三方海外仓，私人地址必填' },
                    { id: 'address1', field: 'address', fieldName: '详细地址', required: '是', dataType: 'string', example: '', description: '第三方海外仓，私人地址必填' },
                    { id: 'receiveName', field: 'receiveName', fieldName: '收件人', required: '是', dataType: 'string', example: '', description: '第三方海外仓，私人地址必填' },
                    { id: 'receivePhone', field: 'receivePhone', fieldName: '收件人电话', required: '是', dataType: 'string', example: '', description: '第三方海外仓，私人地址必填' },
                    { id: 'receiveLandline', field: 'receiveLandline', fieldName: '收件人座机号', required: '是', dataType: 'string', example: '', description: '第三方海外仓，私人地址必填' },
                    { id: 'email', field: 'email', fieldName: '邮箱', required: '是', dataType: 'string', example: '', description: '第三方海外仓，私人地址必填' },
                    { id: 'companyName', field: 'companyName', fieldName: '商业地址的公司名称', required: '否', dataType: 'string', example: '', description: '非必填' },
                    ] 
                },
                // { id: 'orderTake', field: 'orderTake', fieldName: '提货信息', required: '是', dataType: '提货信息', example: '{}', description: '提货信息' ,children:[
                //     { id: 'warehouseId', field: 'warehouseId', fieldName: '交货仓库Id', required: '是', dataType: 'string', example: '73d277d502024515b92ecf9e95c048df', description: '交货方式为送货到仓必填' },
                //     { id: 'warehouseName', field: 'warehouseName', fieldName: '交货仓库名称', required: '是', dataType: 'string', example: '73d277d502024515b92ecf9e95c048df', description: '交货方式为送货到仓必填' },
                //     { id: 'province', field: 'province', fieldName: '省/州/自治区', required: '否', dataType: 'string', example: '', description: '' },
                //     { id: 'city2', field: 'city', fieldName: '市', required: '否', dataType: 'string', example: '', description: '' },
                //     { id: 'district', field: 'district', fieldName: '区/县', required: '否', dataType: 'string', example: '', description: '' },
                //     { id: 'address2', field: 'address', fieldName: '详细地址', required: '否', dataType: 'string', example: '', description: '' },
                //     { id: 'contact', field: 'contact', fieldName: '提货联系人', required: '否', dataType: 'string', example: '', description: '' },
                //     { id: 'phone', field: 'phone', fieldName: '提货联系电话', required: '否', dataType: 'string', example: '', description: '' },
                //     { id: 'takeTime', field: 'takeTime', fieldName: '交货时间', required: '否', dataType: 'string', example: '', description: '' }
                //     ]
                //   },
                 
                ]
            },
          ],
        },
        {
          api:'2-1',
          apiAdd:'2',
          selectedVersion:'V1.0',
          mainTitle: '常规接口HTTP请求头格式',
          h2Title1: '',
          description: '',
          codeLines: `          Authorization:Bearer ACCESS_TOKEN
          Content-Type:application/json`.split('\n'),
          apiDesc:[
          {
              h2Title: '根据订单号获取订单详情',
              requestUrl: '[GET] /v1/order/aafOrder/queryOrderInfoByOrderNo',
              type:"",
              description:"orderNo:下单时返回的orderNo",
              codeLines: `
                  /v1/order/aafOrder/queryOrderInfoByOrderNo?orderNo=AAGM2407010042`.split('\n'),
                  codeLines1: `
                  {
                    "success": true,
                    "reTry": false,
                    "message": "操作成功",
                    "code": 200,
                    "data": {
                        "orderId": "c20c09dafc6d400791e0b91bc1b49d1e",
                        "transportMode": "AIR",
                        "orderStatus": "订单状态（已收货、转运中、已签收、已取消、已退件）",
                        "cabinetType": "1",
                        "countryCode": "GB",
                        "orderType": null,
                        "countryName": "英国",
                        "channelId": "06f73b6cfc914fb1adb80292ca280416",
                        "channelName": "英国空派Send-UK-F-不递延",
                        "cabinetSize": null,
                        "custOrderNo": "2406290003",
                        "isUseCustOrderNo": null,
                        "shipmentId": "FBAABCD1234",
                        "goodsAttrTypeList": [
                            "2",
                            "1"
                        ],
                        "forecastNumber": 1,
                        "chargeableNum": "16.930",
                        "declareType": "3",
                        "receiveType": "1",
                        "orderReceive": {
                            "id": "4b3eea4d93a645e3adba35eabf28d82b",
                            "orderId": "c20c09dafc6d400791e0b91bc1b49d1e",
                            "orderNo": "aaGM2407010042",
                            "warehouseCode": "ORF2",
                            "shipmentType": "1",
                            "fbaWarehouseCode": "ORF2",
                            "fbaWarehouseName": null,
                            "tpWarehouseCode": null,
                            "tpWarehouseName": null,
                            "receiveCountryName": null,
                            "receivePostcode": null,
                            "state": "VA",
                            "city": "CHESAPEAKE",
                            "address": "5045 PORTSMOUTH BLVD",
                            "receiveAddress": "VA-CHESAPEAKE-5045 PORTSMOUTH BLVD",
                            "receiveName": null,
                            "receivePhone": null,
                            "receiveLandline": null,
                            "email": null,
                            "inBoundCode": null,
                            "companyName": null,
                            "isDel": "0",
                            "createTime": "2024-07-01 20:27:13",
                            "createBy": "admin null",
                            "updateTime": null,
                            "updateBy": null
                        },
                        "takeType": "1",
                        "orderTake": {
                            "id": "b6727d5bf3e740cfb4879e48e695cd16",
                            "orderId": "c20c09dafc6d400791e0b91bc1b49d1e",
                            "orderNo": "aaGM2407010042",
                            "type": "1",
                            "contact": null,
                            "phone": null,
                            "takeTime": null,
                            "province": null,
                            "city": null,
                            "district": null,
                            "address": null,
                            "takeAddress": null,
                            "warehouseId": "00c8070b70a1475d90a4724331b85w44",
                            "warehouseName": "深圳市美通一号仓",
                            "remark": null,
                            "createTime": "2024-07-01 20:27:12",
                            "createBy": "admin null",
                            "updateTime": null,
                            "updateBy": null
                        },
                        "orderRemark": null,
                        "orderNo": "aaGM2407010042",
                        "importType": "页面录入",
                        "isPurchaseInsurance": "0",
                        "insuranceType": null,
                        "insuranceCurrency": null,
                        "insuranceAmount": null,
                        "isSpecifyDelivery": null,
                        "deliveryCompanyId": null,
                        "forecastWeight": 100.000,
                        "forecastVolume": 1.000,
                        "isArrangeInspection": null,
                        "goodsAttrObj": {
                            "batteryType": "1",
                            "power": "123",
                            "watts": "123",
                            "documents": "https://public-aaf-shenzhen-file.oss-cn-beijing.aliyuncs.com/aaf1.0/file/鉴定文件.zip"
                        },
                        "orderGoodsList": [
                            {
                                "id": "7eb1b9b4cf5b4fa8b989eff6b28c8d77",
                                "orderId": "c20c09dafc6d400791e0b91bc1b49d1e",
                                "orderNo": "aaGM2407010042",
                                "boxNo": "FBAABCD1234U000002",
                                "shipmentId": "FBAABCD1234",
                                "referenceId": null,
                                "boxWeight": 100.000,
                                "length": 100.000,
                                "width": 100.000,
                                "height": 100.000,
                                "skuEnglishName": "Bluetooth Earphones",
                                "skuName": "蓝牙耳机",
                                "declarePrice": 2.700,
                                "number": 100,
                                "exportHscode": "123",
                                "clearanceHscode": "123",
                                "brand": "无",
                                "brandType": "1",
                                "model": "ABC",
                                "material": "塑料",
                                "purpose": "手机配件",
                                "saleUrl": "https://www.amazon.co.gb/dp/ABCD1234",
                                "salesPrice": 0.000,
                                "picUrl": null,
                                "productWeight": 0.000,
                                "purchasePrice": 2.700,
                                "asin": null,
                                "sku": null,
                                "isElectric": "0",
                                "isMagnetic": "0",
                                "isLiquid": null,
                                "isPowder": null,
                                "isHazardous": null,
                                "isWooden": null,
                                "declareType": "1",
                                "description": null
                            }
                        ],
                        "orderExpenseList": [
                            {
                                "id": "15aee7bf25ea4d1a8e3ab4c92e789a46",
                                "feeName": "费用名称",
                                "cur": "收款币种",
                                "price": 10.0,
                                "unitStr": "单位",
                                "quantity": 14.0000,
                                "total": 140.0000,
                                "toCnyRate": 1.0,
                                "exchangeCnyTotal": 140.0000,
                                "createBy": "admin null",
                                "orderId": "c20c09dafc6d400791e0b91bc1b49d1e",
                                "orderNo": "aaGM2407010042",
                                "createSource": null
                            }
                        ],
                        "orderVolumeList": [
                            {
                                "id": "1919601973256585218",
                                "orderId": "c20c09dafc6d400791e0b91bc1b49d1e",
                                "orderNo": "aaGM2407010042",
                                "boxNo": "123123213123",
                                "number": null,
                                "length": 30.000,
                                "width": 45.000,
                                "height": 62.000,
                                "weight": 9.000,
                                "volume": 0.084,
                                "trackingNumber": null
                            }
                        ],
                        "taxRefundInfo": null,
                        "taxRefundRemark": "1",
                        "taxType": "1",
                        "vatNo": null,
                        "eoriNo": null,
                        "einNo": null,
                        "taxNo": null,
                        "taxId": null,
                        "labelUrl": "http://47.119.160.181:9081/v1/jasper/jasper/downloadGBLabelByOrderNo?orderNo=AAGM2407010042"
                    },
                 "timestamp": 1720081364204
              }`.split('\n'),
                  codeLines2: '',
              tableData:[{ 
              id: 'orderNo', field: 'orderNo', fieldName: '参数', required: '是', dataType: 'string', example: '', description: '' }, ]
            },
          ],
        },
        {
          api:'2-2',
          apiAdd:'3',
          selectedVersion:'V1.0',
          mainTitle: '常规接口HTTP请求头格式',
          h2Title1: '',
          description: '',
          codeLines: `          Authorization:Bearer ACCESS_TOKEN
          Content-Type:application/json`.split('\n'),
          apiDesc:[
          {
              h2Title: '获取渠道信息',
              requestUrl: '[GET] /v1/sys/bdChannel/queryAllChannelList',
              type:"",
              description:"无需传参",
              resultEmbedUrl: 'https://www.szaaf.com/v1/sys/bdChannel/queryAllChannelTable',
              codeLines: `
              /v1/sys/bdChannel/queryAllChannelList`.split('\n'),
                  codeLines1: `
                  {
                      "success": true,
                      "reTry": false,
                      "message": "操作成功",
                      "code": 200,
                      "data": [
                          {
                              "id": "0255c7d5c717461db6deebee27d00bac",
                              "channelName": "加拿大海运快线-普船卡派",
                              "transportMode": "OCEAN"
                          },
                          {
                              "id": "05c91b525c9443039d40821251feb147",
                              "channelName": "德国空派Send-DE-B-Slow-不递延",
                              "transportMode": "AIR"
                          },
                          {
                              "id": "06f73b6cfc914fb1adb80292ca280416",
                              "channelName": "英国空派Send-UK-F-不递延",
                              "transportMode": "AIR"
                          },
                          {
                              "id": "07d664c49d124f41a4dabc31259ff03f",
                              "channelName": "加拿大海运快线-美森快递派",
                              "transportMode": "OCEAN"
                          }
                      ]
                  }
            `.split('\n'),
                  codeLines2: `
                  success:请求成功标志,true仅代表请求成功,不代表通过
                  message:请求描述
                  code:200则代表请求通过,完成下单,500则代表校验未通过
                  data:返回数据
                  id:渠道id
                  channelName:渠道名称
                  transportMode:运输方式:OCEAN-海运, AIR-空运, RAIL-铁路, ROAD-卡航
                  `.split('\n'),
              tableData:[ ]
            },
          ],
        },
        // {
        //   api:'2-3', 
        //   apiAdd:'4',
        //   selectedVersion:'V1.0',
        //   mainTitle: '常规接口HTTP请求头格式',
        //   h2Title1: '',
        //   description: '',
        //   codeLines: `          Authorization:Bearer ACCESS_TOKEN
        //   Content-Type:application/json`.split('\n'),
        //   apiDesc:[
        //   {
        //       h2Title: '获取交货仓库信息',
        //       requestUrl: '[GET] /v1/sys/bdWarehouse/queryWarehouseList',
        //       type:"",
        //       description:"无需传参",
        //       codeLines: `
        //       /v1/sys/bdWarehouse/queryWarehouseList`.split('\n'),
        //           codeLines1: `
        //           {
        //           "success":true,
        //           "reTry":false,
        //           "message":"操作成功",
        //           "code":200,
        //           "data":[
        //                     {
        //                       "warehouseId":"00c8070b70a1475d90a4724331b85d3a",
        //                       "warehouseName":"观澜分拨中心"
        //                     },
        //                     {
        //                       "warehouseId":"00c8070b70a1475d90a4724331b85w44",
        //                       "warehouseName":"佛山1号仓"
        //                     },
        //                     {
        //                       "warehouseId":"293b0a78bd6b4670a68f950dde605d28",
        //                       "warehouseName":"东莞1号仓"
        //                     }
        //               ]
        //           }
        //     `.split('\n'),
        //           codeLines2: `
        //           success:请求成功标志，true仅代表请求成功，不代表通过
        //           message：请求描述
        //           code:200则代表请求通过，完成下单，500则代表校验未通过
        //           warehouseId：交货仓库id
        //           warehouseName：交货仓库名称
        //           `.split('\n'),
        //       tableData:[ ]
        //     },
        //   ],
        // },
        {
          api:'2-4',
          apiAdd:'5',
          selectedVersion:'V1.0',
          mainTitle: '常规接口HTTP请求头格式',
          h2Title1: '',
          description: '',
          codeLines: `          Authorization:Bearer ACCESS_TOKEN
          Content-Type:application/json`.split('\n'),
          apiDesc:[
          {
              h2Title: '获取FBA仓库编码',
              requestUrl: '[GET] /v1/sys/bdFbaCode/queryAllFbaCode',
              type:"",
              description:"无需传参",
              codeLines: `
              /v1/sys/bdFbaCode/queryAllFbaCode`.split('\n'),
                  codeLines1: `
                  {
                    "success": true,
                    "reTry": false,
                    "message": "操作成功",
                    "code": 200,
                    "data": [
                        "XFR2",
                        "SCK4",
                        "ITX2",
                        "BWI4",
                        "ACY2",
                        "DFW8",
                        "EWR9",
                        "VESK",
                        "TPFD",
                        "SAMB",
                        "MAA5",
                        "CAE1"
                    ]
                }
            `.split('\n'),
                  codeLines2: `
                  success:请求成功标志，true仅代表请求成功，不代表通过
                  message：请求描述
                  code:200则代表请求通过，完成下单，500则代表校验未通过
                  data:FBA仓库编码列表
                  `.split('\n'),
              tableData:[ ]
            },
          ],
        },
        {
          api:'2-5',
          apiAdd:'6',
          selectedVersion:'V1.0',
          mainTitle: '常规接口HTTP请求头格式',
          h2Title1: '',
          description: '',
          codeLines: `          Authorization:Bearer ACCESS_TOKEN
          Content-Type:application/json`.split('\n'),
          apiDesc:[
          {
              h2Title: '获取订单轨迹',
              requestUrl: '[GET] /v1/track/aafOrderTrack/getTrackInfo',
              type:"",
              description:"orderNo:下单时返回的订单号",
              codeLines: `
              /v1/track/aafOrderTrack/getTrackInfo?orderNo=2405090002`.split('\n'),
                  codeLines1: `
                  {
                      "success": true,
                      "reTry": false,
                      "message": "操作成功",
                      "code": 200,
                      "data": [
                          {
                              "id": "780bd190515e4d538323bf613fa19a0f",
                              "content": "您的订单已于2025-03-25 23:30:54签收/派送完成。",
                              "eventTime": "2025-03-25 23:30:54",
                              "eventTimeType": "1",
                              "location": "DE",
                              "createBy": null
                          },
                          {
                              "id": "080e3113f2804307882149ea37fd12db",
                              "content": "您的订单国外清关已于当地时间2025-03-24 16:23:29放行。",
                              "eventTime": "2025-03-24 16:23:29",
                              "eventTimeType": "1",
                              "location": "LGG",
                              "createBy": null
                          },
                          {
                              "id": "b3fad32fcd6f4058a89e2a3489cbeac4",
                              "content": "您的订单已于2025-03-23 16:14:21落地。",
                              "eventTime": "2025-03-23 16:14:21",
                              "eventTimeType": "1",
                              "location": "",
                              "createBy": null
                          },
                          {
                              "id": "4193f49d4a9344e1ab92447f511f3fde",
                              "content": "您的订单已于2025-03-22 13:11:18起飞。",
                              "eventTime": "2025-03-22 13:11:18",
                              "eventTimeType": "1",
                              "location": "EHU",
                              "createBy": null
                          },
                          {
                              "id": "7a7772f653f44fc4b31fdc9fc64b5fba",
                              "content": "预配航班：预计2025-03-22起飞，预计2025-03-23落地",
                              "eventTime": "2025-03-19 18:02:31",
                              "eventTimeType": "1",
                              "location": "国内地点",
                              "createBy": null
                          },
                          {
                              "id": "32432e06f337420387442ceba5dbb08d",
                              "content": "您的订单已经入仓",
                              "eventTime": "2025-03-18 11:44:54",
                              "eventTimeType": "1",
                              "location": "国内地点",
                              "createBy": null
                          },
                          {
                              "id": "154a3238edeb4790b240b3a755327df1",
                              "content": "已下单",
                              "eventTime": "2025-03-18 10:12:51",
                              "eventTimeType": "1",
                              "location": "国内地点",
                              "createBy": null
                          }
                      ],
                      "timestamp": 1742989132244
                  }
            `.split('\n'),
                  codeLines2: `
                  success:请求成功标志，true仅代表请求成功，不代表通过
                  message：请求描述
                  code:200则代表请求通过，完成下单，500则代表校验未通过
                  data:订单轨迹数据列表
                  `.split('\n'),
              tableData:[
                    //{ id: 'trackNode1', field: 'trackNode', fieldName: '节点编码', required: '是', dataType: 'String', example: '1400', description: '节点类型' },
                    //{ id: 'trackNodeStr1', field: 'trackNodeStr', fieldName: '节点类型', required: '是', dataType: 'String', example: '到港', description: '节点类型' },
                    { id: 'content3', field: 'content', fieldName: '订单节点内容描述', required: '是', dataType: 'String', example: '', description: '订单节点内容描述' },
                    { id: 'eventTime', field: 'eventTime', fieldName: '事件发生时间', required: '是', dataType: 'Date', example: '2024-05-13 00:00:00', description: '事件发生时间' },
                    { id: 'eventTimeType', field: 'eventTimeType', fieldName: '时间发生时间类型', required: '是', dataType: 'String', example: '2', description: '时间发生时间类型 1、实际发生 2、预计发生' },
                    { id: 'location2', field: 'location', fieldName: '地点', required: '是', dataType: 'String', example: 'PRINCE RUPERT, BC', description: '地点' },
               ]
            },
          ],
        },
        // {
        //   api:'2-6',
        //   apiAdd:'7',
        //   selectedVersion:'V1.0',
        //   mainTitle: '常规接口HTTP请求头格式',
        //   h2Title1: '',
        //   description: '',
        //   codeLines: `          Authorization:Bearer ACCESS_TOKEN
        //   Content-Type:application/json`.split('\n'),
        //   apiDesc:[
        //     {
        //       h2Title: '获取第三方海外仓信息',
        //       requestUrl: '[POST] /v1/sys/bdThirdOverseasWarehouse/queryList',
        //       type:"application/json",
        //       description:"",
        //           codeLines: `
        //           {
        //             "country":"US",
        //             "warehouseCode":"MT",
        //             "company":"Amazon"
        //             }`.split('\n'),
        //           codeLines1: `
        //           {
        //               "success":true,
        //               "reTry":false,
        //               "message":"操作成功",
        //               "code":200,
        //               "data":[
        //                    {
        //                    "id":"3dab6656127c4622a715a3a23fe98db7",
        //                    "warehouseCode":"MT0004",
        //                    "country":"US",
        //                    "countryStr":"US-美国",
        //                    "address":"广东省",
        //                    "company":"Amazon"
        //                    }
        //               ],
        //               "timestamp":1720063477558
        //           }`.split('\n'),
        //           codeLines2: `
        //           success:请求成功标志，true仅代表请求成功，不代表通过
        //           message：请求描述
        //           code:200则代表请求通过，完成下单，500则代表校验未通过
        //           data:返回第三方海外仓数据列表
        //           id:主键id
        //           warehouseCode:仓库代码
        //           country:国家二字码
        //           countryStr:国家名称
        //           address:仓库地址
        //           company:仓库所属公司
        //           `.split('\n'),
        //       tableData:[
        //     {id: 'country', field: 'country', fieldName: '国家', required: '否', dataType: 'string', example: 'US', description: '仓库所在国家，传国家二字码' },
        //     {id: 'warehouseCode', field: 'warehouseCode', fieldName: '仓库编码', required: '否', dataType: 'string', example: 'MT1001', description: '仓库代码，模糊查询' },
        //     {id: 'company', field: 'company', fieldName: '仓库所属公司', required: '否', dataType: 'string', example: 'Amazon', description: '仓库所属公司，模糊查询' },
                 
        //         ]
        //     },
        //   ],
        // },
        {
          api:'2-6',
          apiAdd:'8',
          selectedVersion:'V1.0',
          mainTitle: '常规接口HTTP请求头格式',
          h2Title1: '',
          description: '',
          codeLines: `          Authorization:Bearer ACCESS_TOKEN
          Content-Type:application/json`.split('\n'),
          apiDesc:[
            {
              h2Title: '取消订单',
              requestUrl: '[POST] /v1/order/aafOrder/cancelByOrderNo',
              type:"application/json",
              description:"orderNo:下单时返回的订单orderNo",
                  codeLines: `
                  {
                      "orderNo" : "AAGM2407010042"
                  }`.split('\n'),
                  codeLines1: `
                    {
                      "success": true,
                      "reTry": false,
                      "message": "操作成功",
                      "code": 200,
                      "data": "订单取消成功",
                      "timestamp": 1719836871024
                  }`.split('\n'),
                  codeLines2: '',
              tableData:[
            { 
              id: 'id', field: 'id', fieldName: '参数', required: '是', dataType: 'string', example: '', description: '' },
                 
                ]
            },
          ],
        },
        {
          api:'2-3',
          apiAdd:'9',
          selectedVersion:'V1.0',
          mainTitle: '常规接口HTTP请求头格式',
          h2Title1: '',
          description: '',
          codeLines: `          Authorization:Bearer ACCESS_TOKEN
          Content-Type:application/json`.split('\n'),
          apiDesc:[
          {
              h2Title: 'VAT号带搜索条件下拉',
              requestUrl: '[GET] /v1/sys/bdVat/getVatByVatNo',
              type:"application/json",
              description:"searchKey: VAT号, countryCode: 国家",
              codeLines: `
                {
                    "vatNo" : "DE12123123",
                    "countryCode" : "DE"
                }`.split('\n'),
              codeLines1: `
                {
                  "success": true,
                  "reTry": false,
                  "message": "操作成功",
                  "code": 200,
                  "data": [
                      {
                          "vatNo": "DE12123123"
                      }
                  ],
                  "timestamp": 1749027914978
                }
            `.split('\n'),
                  codeLines2: `
                  success: 请求成功标志，true仅代表请求成功，不代表通过
                  message：请求描述
                  code: 200则代表请求通过，完成下单，500则代表校验未通过
                  data: VAT数据列表
                  `.split('\n'),
              tableData:[
                    { id: 'vatNo', field: 'vatNo', fieldName: 'VAT号', required: '否', dataType: 'String', example: '', description: '' },
                    { id: 'countryCode', field: 'countryCode', fieldName: '国家', required: '否', dataType: 'String', example: '', description: '' },
               ]
            },
          ],
        },
        {
          api:'1-0',
          apiAdd:'1',
          selectedVersion:'oldSystem',
          mainTitle: '常规接口HTTP请求头格式',
          h2Title1: '',
          description: '',
          codeLines: `          Authorization:Bearer ACCESS_TOKEN
          Content-Type:application/json`.split('\n'),
          apiDesc:[
          {
              h2Title: '创建运单',
              requestUrl: '[POST] /v1/order/aafOrder/create',
              type:"",
              description:"",
              description1: '注：蓝色字体为兼容老系统和新接口所需的新增字段',

              codeLines: `
              {
                  "shipment": {
                      "service": "B2B",
                      <span style="color: #0076f6;">"shipmentType": "1",</span>
                      <span style="color: #0076f6;">"transportMode": "AIR",</span>
                      "store_id": "",
                      "client_reference": "",
                      "parcel_count": 2,
                      "export_scc": 0,
                      "import_scc": 0,
                      "attrs": [
                      ],
                      "vat_number": "",
                      "ioss": "",
                      "from_address": {
                          "name": "API TEST",
                          "company": "ParcelC",
                          "tel": "1818181811",
                          "mobile": "",
                          "address_1": "Amazonstrasse 1",
                          "address_2": "",
                          "address_3": "",
                          "city": "Rheinberg",
                          "state": "",
                          "country": "DE",
                          "postcode": "47495",
                          "email": ""
                      },
                      "to_address": {
                          "name": "API TEST",
                          "company": "ParcelC",
                          "tel": "1818181811",
                          "mobile": "",
                          "address_1": "Amazonstrasse 1",
                          "address_2": "",
                          "address_3": "",
                          "city": "Rheinberg",
                          "state": "",
                          "country": "DE",
                          "postcode": "47495",
                          "email": ""
                      },
                      "parcels": [
                          {
                              "number": 1,
                              "client_weight": 2,
                              "client_length": 3,
                              "client_width": 4,
                              "client_height": 5,
                              "declarations": [
                                  {
                                      "sku": "testsku",
                                      "name_zh": "zhongwenming",
                                      "name_en": "yingwenming",
                                      "unit_value": 11,
                                      "qty": 1,
                                      "material": "glass",
                                      "usage": "play",
                                      "brand": "",
                                      "sale_price": 0,
                                      "sale_url": "",
                                      "asin": "",
                                      "fnsku": "fnsku",
                                      "weight": 0,
                                      "size": "",
                                      "photo_url": "",
                                      "hscode": 1234567890,
                                      "duty_rate": 0,
                                      "origin": "",
                                      "photos": "",
                                      "title": "",
                                      "description": ""
                                  },
                                  {
                                      "sku": "testsku2",
                                      "name_zh": "zhongwenming2",
                                      "name_en": "yingwenming2",
                                      "unit_value": 22,
                                      "qty": 2,
                                      "material": "glass",
                                      "usage": "play",
                                      "brand": "",
                                      "sale_price": 0,
                                      "sale_url": "",
                                      "asin": "",
                                      "fnsku": "fnsku",
                                      "weight": 0,
                                      "size": "",
                                      "photo_url": "",
                                      "hscode": 1234567890,
                                      "duty_rate": 0,
                                      "origin": "",
                                      "photos": "",
                                      "title": "",
                                      "description": ""
                                  }
                              ]
                          },
                          {
                              "number": 2,
                              "client_weight": 2,
                              "client_length": 3,
                              "client_width": 4,
                              "client_height": 5,
                              "declarations": [
                                  {
                                      "sku": "testsku",
                                      "name_zh": "zhongwenming",
                                      "name_en": "yingwenming",
                                      "unit_value": 11,
                                      "qty": 1,
                                      "material": "glass",
                                      "usage": "play",
                                      "brand": "",
                                      "sale_price": 0,
                                      "sale_url": "",
                                      "asin": "",
                                      "fnsku": "fnsku",
                                      "weight": 0,
                                      "size": "",
                                      "photo_url": "",
                                      "hscode": 1234567890,
                                      "duty_rate": 0,
                                      "origin": "",
                                      "photos": "",
                                      "title": "",
                                      "description": ""
                                  },
                                  {
                                      "sku": "testsku2",
                                      "name_zh": "zhongwenming2",
                                      "name_en": "yingwenming2",
                                      "unit_value": 22,
                                      "qty": 2,
                                      "material": "glass",
                                      "usage": "play",
                                      "brand": "",
                                      "sale_price": 0,
                                      "sale_url": "",
                                      "asin": "",
                                      "fnsku": "fnsku",
                                      "weight": 0,
                                      "size": "",
                                      "photo_url": "",
                                      "hscode": 1234567890,
                                      "duty_rate": 0,
                                      "origin": "",
                                      "photos": "",
                                      "title": "",
                                      "description": ""
                                  }
                              ]
                          }
                      ],
                      "remark": ""
                  }
              }`.split('\n'),
                  codeLines1: `
                  {
                      "status": 1,
                      "info": "请求成功的完成",
                      "time": 1529458913,
                      "data": {
                          "shipment": {
                              "shipment_id": "10000060"
                          }
                      }
                  }
                  如果是二次换标的渠道，relabel为1，这里会直接返回系统标签，无需二次请求标签:
                  {
                      "status": 1,
                      "info": "请求成功的完成",
                      "time": 1529458913,
                      "data": {
                          "shipment": {
                              "shipment_id": "10000060",
                              "relabel": 1,
                              "parcels": [
                                  {
                                      "item_number": "10000060",
                                      "label_url": ""
                                  }
                              ]
                          }
                      }
                  }
               `.split('\n'),
                  codeLines2: `
                  status	状态	是	Int	1请求成功，0请求失败
                  info	原因	是	String	
                  time	请求返回时间戳	否	Int	
                  data.shipment.shipment_id	运单号	否	String	
                  data.shipment.relabel	是否换标	否	String	0 代表不用换标，get_labels获取的是末端标签；1 代表要换标，获取的是系统标签，可以直接取下面parcels字段里面的标签
                  data.shipment.parcels.item_number	箱号	否	String	
                  data.shipment.parcels.label_url	标签文档的url地址	否	String	访问这个地址就能下载标签，标签格式是pdf `.split('\n'),
               tableData:[
                    { id: 'shipment', field: 'shipment', fieldName: '订单信息', required: '是', dataType: 'Shipment Object', example: '', description: '订单详细信息',children:[
                    { id: 'service', field: 'service', fieldName: '渠道', required: '是', dataType: 'String', example: '', description: '渠道必填 通过/v1/sys/bdChannel/queryAllChannelList接口可以查看' },
                    { id: 'shipmentType', field: 'shipmentType', fieldName: '收件地址类型', required: '是', dataType: 'string', example: '1', description: '地址类型必填 1:FBA地址 2：第三方海外仓 3：商业地址 4:住宅地址' },
                    { id: 'takeType', field: 'takeType', fieldName: '交货方式', required: '是', dataType: 'String', example: '1', description: '交货方式必填 1:自送到仓 2：上门提货' },
                    { id: 'warehouseId', field: 'warehouseId', fieldName: '交货仓库id', required: '是', dataType: 'String', example: '', description: '当选择上门提货时必填，数据从/v1/sys/bdWarehouse/queryWarehouseList接口中获取' },
                    { id: 'transportMode', field: 'transportMode', fieldName: '运输方式', required: '是', dataType: 'string', example: 'AIR', description: '海运-OCEAN, 空运-AIR, 铁路-RAIL, 卡航-ROAD' },
                    { id: 'store_id', field: 'store_id', fieldName: '店铺名称', required: '否', dataType: 'String', example: '', description: '默认为空' },
                    { id: 'client_reference', field: 'client_reference', fieldName: '客户订单号', required: '否', dataType: 'String', example: '', description: '' },
                    { id: 'reference_1', field: 'reference_1', fieldName: '参考号一', required: '否', dataType: 'String', example: '', description: '' },
                    { id: 'reference_2', field: 'reference_2', fieldName: '参考号二', required: '否', dataType: 'String', example: '', description: '' },
                    { id: 'parcel_count', field: 'parcel_count', fieldName: '箱子总数', required: '是', dataType: 'String', example: '', description: '' },
                    { id: 'taxwith', field: 'taxwith', fieldName: '交税方式', required: '否', dataType: 'Int', example: '0', description: '默认值为0 什么都不选择；1 不包税；2 包税；3 自主税号；4 自税递延 交税方式必填' },
                    { id: 'deliverywith', field: 'deliverywith', fieldName: '交货条款', required: '否', dataType: 'String', example: '', description: '默认为空。ddu代表DDU; ddp代表DDP' },
                    { id: 'exportwith', field: 'exportwith', fieldName: '报关', required: '否', dataType: 'Int', example: '0', description: '报关必填  1 代理报关；2 报关退税 ' },
                    { id: 'importwith', field: 'importwith', fieldName: '清关', required: '否', dataType: 'Int', example: '0', description: '默认值为0 什么都不选择；1 一般贸易清关；2 快件清关' },
                    { id: 'attrs', field: 'attrs', fieldName: '物品属性', required: '否', dataType: 'array', example: '["elec", "magnetic"]', description: '产品属性必填 带电：elec 带磁：magnetic 危险品：danger 液体：liquid 粉末：powder 膏体：paste 敏感货：sensitive_goods 木制品：wood 纺织品：textile ' },
                    { id: 'vat_number', field: 'vat_number', fieldName: 'vat号', required: '否', dataType: 'String', example: '', description: '' },
                    { id: 'ioss', field: 'ioss', fieldName: 'IOSS号', required: '否', dataType: 'String', example: '', description: '' },
                    { id: 'eori', field: 'eori', fieldName: 'eori号', required: '否', dataType: 'String', example: '', description: '' },
                    { id: 'cod_amount', field: 'cod_amount', fieldName: '代收金额', required: '否', dataType: 'String', example: '', description: '' },
                    { id: 'cod_currency', field: 'cod_currency', fieldName: '代收币种', required: '否', dataType: 'String', example: '', description: '' },
                    { id: 'declaration_currency', field: 'declaration_currency', fieldName: '申报币种', required: '否', dataType: 'String', example: '', description: '' },
                    { id: 'amazon_ref_id', field: 'amazon_ref_id', fieldName: 'Amazon Reference ID', required: '否', dataType: 'String', example: '', description: '' },
                    { id: 'to_warehouse_code', field: 'to_warehouse_code', fieldName: '仓库代码', required: '否', dataType: 'String', example: '', description: '收件地址必填 收件地址类型是FBA/海外仓，则必填，数据从获取FBA仓库编码/获取海外仓仓库编码接口中获取 ' },
                    { id: 'to_address', field: 'to_address', fieldName: '收件人地址', required: '是', dataType: 'Address Object', example: '', description: '目的国家必填' },
                    { id: 'from_address', field: 'from_address', fieldName: '发件人地址', required: '条件', dataType: 'Address Object', example: '', description: '选填，如果填了，Address Object必填项要填上' },
                    { id: 'parcels', field: 'parcels', fieldName: '箱子', required: '是', dataType: 'Parcels Object Array', example: '', description: '' },
                    { id: 'remark', field: 'remark', fieldName: '备注', required: '否', dataType: 'String', example: '', description: '' }
                    ] 
                  },
                  { id: 'Address', field: 'Address', fieldName: '地址相关', required: '是', dataType: 'Address Object', example: '', description: '',children:[
                  { id: 'name', field: 'name', fieldName: '名称', required: '是', dataType: 'String', example: '张三', description: '' },
                  { id: 'company', field: 'company', fieldName: '公司名', required: '否', dataType: 'String', example: '某科技公司', description: '' },
                  { id: 'tel', field: 'tel', fieldName: '电话', required: '否', dataType: 'String', example: '021-123456', description: '' },
                  { id: 'mobile', field: 'mobile', fieldName: '手机', required: '否', dataType: 'String', example: '13812345678', description: '' },
                  { id: 'city', field: 'city', fieldName: '城市', required: '是', dataType: 'String', example: '上海', description: '' },
                  { id: 'state', field: 'state', fieldName: '省/州', required: '否', dataType: 'String', example: '浙江省', description: '' },
                  { id: 'state_code', field: 'state_code', fieldName: '省/州代码', required: '否', dataType: 'String', example: 'ZJ', description: '' },
                  { id: 'country', field: 'country', fieldName: '国家', required: '是', dataType: 'String', example: '中国', description: '' },
                  { id: 'postcode', field: 'postcode', fieldName: '邮编', required: '是', dataType: 'String', example: '200000', description: '' },
                  { id: 'email', field: 'email', fieldName: '邮箱', required: '否', dataType: 'String', example: 'example@email.com', description: '' },
                  { id: 'ext', field: 'ext', fieldName: '附加信息', required: '否', dataType: 'Ext Object', example: '{}', description: '包含扩展信息的对象' },
                  { id: 'address_1', field: 'address_1', fieldName: '地址一', required: '是', dataType: 'String', example: '某街道某号', description: '' },
                  { id: 'address_2', field: 'address_2', fieldName: '地址二', required: '否', dataType: 'String', example: '某大楼某层', description: '' },
                  { id: 'address_3', field: 'address_3', fieldName: '地址三', required: '否', dataType: 'String', example: '某单元某室', description: '' }
                  ]},
                  { id: 'Ext Object', field: 'Ext Object', fieldName: 'EXT相关', required: '否', dataType: 'Ext Object', example: '', description: '',children:[
                  { id: 'identity_card_no', field: 'identity_card_no', fieldName: '身份证号码', required: '否', dataType: 'String', example: '', description: '' }
                  ]},
                  { id: 'Parcels Object Array', field: 'Parcels Object Array', fieldName: 'Parcels Object Array', required: '', dataType: 'Parcels Object Array', example: '', description: '货物/产品明细必填',children:[
                  { id: 'number', field: 'number', fieldName: '箱号', required: '是', dataType: 'String', example: 'FBAABCD1234U000001', description: '按1，2，3…顺序递增。有FBA箱号可以填写FBA箱号' },
                  { id: 'client_weight', field: 'client_weight', fieldName: '重量', required: '条件', dataType: 'Number', example: '5', description: '单位kg。如果调用修改客户重量尺寸接口则必填' },
                  { id: 'client_length', field: 'client_length', fieldName: '长', required: '否', dataType: 'Number', example: '120', description: '单位cm' },
                  { id: 'client_width', field: 'client_width', fieldName: '宽', required: '否', dataType: 'Number', example: '80', description: '单位cm' },
                  { id: 'client_height', field: 'client_height', fieldName: '高', required: '否', dataType: 'Number', example: '60', description: '单位cm' },
                  { id: 'declarations', field: 'declarations', fieldName: '申报信息', required: '是', dataType: 'Declarations Object Array', example: '', description: '中文品名和英文品名为必填，其他哪些必填需要跟客服联系' }
                  ]},
                  { id: 'Declarations Object Array', field: 'Declarations Object Array', fieldName: 'Declarations Object Array', required: '', dataType: 'Declarations Object Array', example: '', description: '',children:[
                  { id: 'sku', field: 'sku', fieldName: 'SKU', required: '否', dataType: 'String', example: 'SKU12345', description: '' },
                  { id: 'name_zh', field: 'name_zh', fieldName: '中文品名', required: '是', dataType: 'String', example: '蓝牙耳机', description: '' },
                  { id: 'name_en', field: 'name_en', fieldName: '英文品名', required: '是', dataType: 'String', example: 'Bluetooth Headphones', description: '' },
                  { id: 'unit_value', field: 'unit_value', fieldName: '申报单价', required: '否', dataType: 'Number', example: '50.00', description: '' },
                  { id: 'qty', field: 'qty', fieldName: '申报数量', required: '否', dataType: 'Int', example: '100', description: '' },
                  { id: 'material', field: 'material', fieldName: '材质', required: '否', dataType: 'String', example: '塑料', description: '' },
                  { id: 'usage', field: 'usage', fieldName: '用途', required: '否', dataType: 'String', example: '个人使用', description: '' },
                  { id: 'brand', field: 'brand', fieldName: '品牌名称', required: '否', dataType: 'String', example: 'Generic', description: '' },
                  { id: 'brand_type', field: 'brand_type', fieldName: '品牌类型', required: '否', dataType: 'String', example: '国际品牌', description: '' },
                  { id: 'model', field: 'model', fieldName: '型号', required: '否', dataType: 'String', example: 'Model X', description: '' },
                  { id: 'sale_price', field: 'sale_price', fieldName: '销售价格', required: '否', dataType: 'Number', example: '99.99', description: '' },
                  { id: 'sale_url', field: 'sale_url', fieldName: '销售链接', required: '否', dataType: 'String', example: 'http://example.com/product', description: '' },
                  { id: 'asin', field: 'asin', fieldName: 'ASIN', required: '否', dataType: 'String', example: 'B00XXXXXX', description: '' },
                  { id: 'fnsku', field: 'fnsku', fieldName: 'FNSKU', required: '否', dataType: 'String', example: 'X000XXXXXX', description: '' },
                  { id: 'weight', field: 'weight', fieldName: '单个产品重量', required: '否', dataType: 'Number', example: '0.2', description: '单位kg' },
                  { id: 'size', field: 'size', fieldName: '尺寸', required: '否', dataType: 'String', example: '10*10*10', description: '格式:长*宽*高' },
                  { id: 'photo_url', field: 'photo_url', fieldName: '图片链接', required: '否', dataType: 'String', example: 'http://example.com/image.jpg', description: '' },
                  { id: 'hscode', field: 'hscode', fieldName: '海关编码', required: '否', dataType: 'String', example: '8517.12', description: '' },
                  { id: 'duty_rate', field: 'duty_rate', fieldName: '税率', required: '否', dataType: 'Number', example: '10%', description: '' },
                  { id: 'origin', field: 'origin', fieldName: '产地', required: '否', dataType: 'String', example: '中国', description: '' },
                  { id: 'photos', field: 'photos', fieldName: '图片', required: '否', dataType: 'String', example: 'http://example.com/photo1.jpg; http://example.com/photo2.jpg', description: '' },
                  { id: 'is_battery', field: 'is_battery', fieldName: '产品是否带电', required: '否', dataType: 'Int', example: '1', description: '默认为0。1为是，0为否' },
                  { id: 'is_magnetic', field: 'is_magnetic', fieldName: '产品是否带磁', required: '否', dataType: 'Int', example: '0', description: '默认为0。1为是，0为否' },
                  { id: 'battery_label', field: 'battery_label', fieldName: '电池标号', required: '否', dataType: 'String', example: 'BL-5C', description: '' },
                  { id: 'battery_description', field: 'battery_description', fieldName: '电池描述', required: '否', dataType: 'String', example: '锂离子电池', description: '' },
                  { id: 'title', field: 'title', fieldName: '产品标题', required: '否', dataType: 'String', example: '高性能蓝牙耳机', description: '' },
                  { id: 'description', field: 'description', fieldName: '产品描述', required: '否', dataType: 'String', example: '耐用且轻便，适合所有类型的户外活动。', description: '' },
                  { id: 'platform', field: 'platform', fieldName: '平台', required: '否', dataType: 'String', example: 'Amazon', description: '' },
                  { id: 'amazon_ref_id', field: 'amazon_ref_id', fieldName: '亚马逊的Amazon Reference Id', required: '否', dataType: 'String', example: 'REF1234567', description: '如果是同一个运单的话就填相同的，不同的话就填对应的' },
                  { id: 'unit', field: 'unit', fieldName: '单位', required: '否', dataType: 'String', example: '件', description: '' }
                  ]},
               ]
            },
          ],
        },
        // 其他数据对象
      ]
    };
  },
  computed: {
    codeLines() {
      return this.code.split('\n');
    },
  },
  methods: {
    embedStatus(url) {
      return this.resultEmbedByUrl[url] || { loading: false, error: '', html: '' };
    },
    resolveResultEmbedFetchUrl(url) {
      if (!url) return url;
      if (
        process.env.NODE_ENV === 'development' &&
        url.indexOf('szaaf.com/v1/sys/bdChannel/queryAllChannelTable') !== -1
      ) {
        return '/ext-szaaf-channel-table';
      }
      return url;
    },
    sanitizeRemoteHtml(raw) {
      if (typeof raw !== 'string') return '';
      const doc = new DOMParser().parseFromString(raw, 'text/html');
      doc.querySelectorAll('script, iframe, object, embed, link[rel="import"]').forEach((el) => {
        el.remove();
      });
      return doc.body ? doc.body.innerHTML : raw;
    },
    ensureResultEmbedLoaded(canonicalUrl) {
      if (!canonicalUrl) return;
      const existing = this.resultEmbedByUrl[canonicalUrl];
      if (existing && existing.loading) return;
      if (existing && existing.html) return;
      const fetchUrl = this.resolveResultEmbedFetchUrl(canonicalUrl);
      this.$set(this.resultEmbedByUrl, canonicalUrl, { loading: true, error: '', html: '' });
      this.$http
        .get(fetchUrl, { responseType: 'text' })
        .then((res) => {
          const raw = typeof res.data === 'string' ? res.data : String(res.data || '');
          const html = this.sanitizeRemoteHtml(raw);
          this.$set(this.resultEmbedByUrl, canonicalUrl, { loading: false, error: '', html });
        })
        .catch(() => {
          this.$set(this.resultEmbedByUrl, canonicalUrl, {
            loading: false,
            error: '内容加载失败，请检查网络或跨域配置，也可使用「新窗口打开」查看。',
            html: '',
          });
        });
    },
    syncResultEmbedFetches(apiData) {
      if (!apiData || !apiData.length) return;
      apiData.forEach((block) => {
        (block.apiDesc || []).forEach((it) => {
          if (it.resultEmbedUrl) {
            this.ensureResultEmbedLoaded(it.resultEmbedUrl);
          }
        });
      });
    },
    rowClassName({ row, rowIndex }) {
      const selected = this.$route.query.selectedVersion;
      // console.log(selectedVersion,row, rowIndex,'selectedVersionselectedVersion')
    if ((
      row.id === 'transportMode' || 
      row.id === 'shipmentType'||
      row.id === 'service'||
      row.id === 'takeType'||
      row.id === 'warehouseId'||
      row.id === 'to_warehouse_code'||
      row.id === 'exportwith'||
      row.id === 'attrs'||
      row.id === 'to_address'||
      row.id === 'Parcels Object Array'
      )&&selected==='oldSystem') {
      return 'blueTips';
    }
  },
    fetchData(api,selected) {
      console.log(api,selected,'selectedVe666rsionselectedVersion')

      // 模拟 API 数据，根据实际情况修改
    
      
          console.log(api,'api,',selected,'selected')
      // 根据 api 参数筛选数据
      this.apiData = this.allData.filter(item => item.api === api && item.selectedVersion === selected);
    },
    copyToClipboard (text)  {
      const code = text.join('\n');
      const textArea = document.createElement('textarea');
      textArea.value = code;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
      this.$message({
          message: '代码已复制到剪贴板',
          type: 'success',
          center: true
        });
    },
    openResultEmbed(url) {
      if (!url) return;
      window.open(url, '_blank', 'noopener,noreferrer');
    },
    handleOpen(key, keyPath) {
      // handle open
    },
    handleClose(key, keyPath) {
      // handle close
    },
    filteredMenuItems(val) {
      this.propList = [];
      if (val === "") {
        return this.menuItems; // 如果没有搜索查询，返回全部
      }
      const searchLower = `${val}`;
      const append = this.menuItems.map((item, index) => {
        const key = Object.keys(this.menuItems[index])[0];
        const eleIndex = item[key].findIndex(element => searchLower === element.title.toLowerCase());
        if (eleIndex !== -1) {
          return { groupIndex: index, itemIndex: eleIndex, item: item[key][eleIndex] };
        }
      });
      const appendData = append.filter(x => x !== undefined);
      const index = `${appendData[0].groupIndex + 1}`;
      this.propList.push(index);
    }
  },
  created() {
    const api = this.$route.query.api;
    const selectedVersion = this.$route.query.selectedVersion;
    if (api) {
      this.fetchData(api,selectedVersion);
    }
  },
  watch: {
  // 监听 api 变化
  '$route.query': {
    deep: true,
    handler(query) {
      if (query.api && query.selectedVersion) {
        this.fetchData(query.api, query.selectedVersion);
      }
    },
    immediate: true
  },
  apiData: {
    deep: true,
    immediate: true,
    handler(val) {
      this.syncResultEmbedFetches(val);
    },
  },
}
};
</script>
<style src="./index.css" scoped></style>
<style>
  .blueTips {
    color: #0076f6;
  }
  .allTips {
    color: #000;
  }
</style>
